import VCard from './VCard.vue';
import VCardTitle from "./VCardTitle";
import VCardSubitle from './VCardSubtitle.vue';
import VCardText from './VCardText.vue';
import VCardActions from './VCardActions.vue';

export { VCard, VCardTitle, VCardSubitle, VCardText, VCardActions };
export default { VCard, VCardTitle, VCardSubitle, VCardText, VCardActions };
